import { SelectProps } from "@cofano/cck/Select/Select";
import { DemurrageCalculationRoundingScope } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const RoundingScopeSelect = ({ value, onChange }: Omit<SelectProps<DemurrageCalculationRoundingScope, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(DemurrageCalculationRoundingScope)}
			getOptionLabel={(option) => intl.formatMessage({ id: `ROUNDING_SCOPE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default RoundingScopeSelect;
